import {useCallback, useState} from "react";
import {getPrompts} from "../services/PromptsService";

export const usePrompts = () => {
  const [prompts, setPrompts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Updated fetchPrompts to handle both old signature and new filters object
  const fetchPrompts = useCallback(async (companyIdOrFilters) => {
    setLoading(true);
    setError(null);

    try {
      const res = await getPrompts(companyIdOrFilters);
      setPrompts(res.data);
    } catch (err) {
      setError(err.message || "Failed to fetch prompts");
      console.error("Error fetching prompts:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    prompts,
    loading,
    error,
    fetchPrompts
  };
};